import { useState } from "react";
import { toast } from "react-toastify";
import api from "../../../utils/api";
import SectionShell from "./SectionShell";

const ResetSuperAdminPasswordSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isResetting, setIsResetting] = useState(false);

  const resetPassword = async () => {
    if (isResetting) return;
    setIsResetting(true);
    try {
      const res = await api.post("/settings/reset-superadmin-password");
      toast.success(res?.data?.message || "Password reset successfully");
      setIsOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to reset password");
    } finally {
      setIsResetting(false);
    }
  };

  return (
    <>
      <SectionShell
        number="6"
        title="Reset SuperAdmin Password"
        subtitle="Resets the SuperAdmin password to the server env configured value."
      >
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-xs text-gray-600">
            This will force SuperAdmin to change password on next login.
          </div>
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            className="w-full md:w-auto bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200"
          >
            Reset Password
          </button>
        </div>
      </SectionShell>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div
            className="fixed inset-0 bg-black/40"
            onClick={() => (isResetting ? null : setIsOpen(false))}
          />
          <div className="relative z-10 w-full max-w-md bg-white rounded-2xl border border-gray-100 shadow-xl p-6">
            <h3 className="text-sm font-semibold text-gray-900">
              Reset SuperAdmin password?
            </h3>
            <p className="text-xs text-gray-600 mt-2">
              Are you sure you want to reset the SuperAdmin password? This action
              cannot be undone.
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                disabled={isResetting}
                className="px-4 py-2 rounded-xl text-sm font-semibold border border-gray-200 bg-white hover:bg-gray-50 disabled:opacity-70"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={resetPassword}
                disabled={isResetting}
                className="px-4 py-2 rounded-xl text-sm font-semibold bg-red-600 hover:bg-red-700 text-white disabled:opacity-70"
              >
                {isResetting ? "Resetting..." : "Yes, Reset"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetSuperAdminPasswordSection;
